import React from "react";
import { CustomInputSelect } from "../../CustomInputSelect";
import { useForm, Controller } from "react-hook-form";
import { CustomInputArea } from "../../CustomInputArea";
import { CustomButtonsForm } from "../../CustomButtonsForm";
import { useUsers } from "../../../hooks/useUsers";
import { convertirLetraMayus } from "../../../helpers/convertirLetraMayus";

export const GenerateAssetsForm = ({ action }) => {

    const { handleSubmit, control, formState: { errors } } = useForm();
    const { users } = useUsers();

	return (
        <form onSubmit={ handleSubmit(action) } style={{ padding: '30px 30px 20px 30px', width: '100%' }}>
            <Controller 
                name='usuario'
                control={control}
                defaultValue=''
                render={ ({ field: { onChange, value } }) => (
                    <CustomInputSelect
                        label="Colaborador"
                        options={ users.map(a => ({ ...a, name: convertirLetraMayus(a?.nombre, true) })) }
                        error={ errors?.usuario } 
                        onChange={ onChange }
                        value={ value }
                        placeholder='Seleccione un colaborador'
                    />
                ) }
                rules={{ 
                    required: 'El campo es obligatorio.',
                    pattern: {
                        value: /^[^\s][a-zA-Z0-9 ].+[^\s]$/,
                        message: "El usuario no es válido.",
                    }
                }}
            />

            <Controller 
                name='observaciones'
                control={control}
                defaultValue=''
                render={ ({ field: { onChange, value } }) => (
                    <CustomInputArea
                        label='Observaciones'
                        placeholder=''
                        onChange={ onChange }
                        value={ value }
                        error={ errors?.observaciones }
                    />
                ) }     
            />

            <CustomButtonsForm name='Procesar' />
        </form>
    )
}